import { BlindConfigService } from "../Common/BlindConfigurations/BlindConfigService";
export class Srp22ConfigService extends BlindConfigService {
    constructor() {
        super();
    }
    GetServiceName() {
        return Srp22ConfigService.ServiceName;
    }
}
Srp22ConfigService.ServiceName = "Srp22ConfigService";
//# sourceMappingURL=Srp22ConfigService.js.map